<template>
    <img
        src="@/assets/icons/WorkstateLightBlue.ico"
        alt="App Icon"
        class="icon mr-2"
    />
</template>

<script setup lang="ts">
</script>

<style scoped>
.icon {
    width: 28px;
    height: 28px;
}

.mr-2 {
    margin-right: 12px;
}
</style>